<div class="modal-header-custom d-flex flex-row">
    <mat-icon (click)="close()" class="close">close</mat-icon>
</div>
<div class="modal-title d-flex flex-row">
    <mat-icon>event_note</mat-icon>
    <h2>{{ 'EVENTS.CAPACITY_LIMIT' | translate }}</h2>
</div>

<mat-dialog-content [formGroup]="venueForm">
    <mat-horizontal-stepper #stepper>
        <mat-step>
            <div class="row mb-1">
                <div class="col-12">
                    <div class="d-flex flex-row label justify-content-between align-items-end">
                        <div>
                            {{ 'VENUES.MAX_GUEST_CAPACITY' | translate }}
                        </div>
                        <div class="d-flex flex-row align-items-end">
                         <mat-icon *ngIf="capacity<=venueMaxCapacity" class="profile">person</mat-icon>
                         <mat-icon *ngIf="capacity>venueMaxCapacity" class="profile-invalid">person</mat-icon>
                         <div class="end-item">{{ venueMaxCapacity }}</div>
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="row">
                <div class="col-12"><!--maxCapacity when is diselected should have null-->
                    <app-capacity [maximumCapacity]="venueMaxCapacity" [numberOfGuests]="capacity" (shareCapacity)="shareCapacity($event)" [canSetReservationLimit]="canSetReservationLimit" [labelName]="('EVENTS.CAPACITY_LIMIT' | translate)"></app-capacity>
                </div>
            </div>

            <div class="row mt-1">
                <div class="col-6">
                    <button mat-button class="mat-bakcground-primary mat-raised-button"(click)="save()" [disabled]="capacity == 0 || capacity>venueMaxCapacity">{{ 'SAVE' | translate }}</button>
                    <!-- <button *ngIf="edit" class="mat-bakcground-primary mat-raised-button"(click)="save()">Save Changes</button> -->
                </div>
                <div class="col-6">
                    <button mat-button class="mat-raised-button"(click)="close()">{{ 'CANCEL' | translate }}</button>
                    <!-- <button *ngIf="edit" class="mat-raised-button"(click)="close()">Cancel Changes</button> -->
                </div>
            </div>
        </mat-step> 
        
    </mat-horizontal-stepper>

</mat-dialog-content>

<!--<mat-dialog-actions>
    <button class="mat-raised-button"(click)="close()">Close</button>
    <button class="mat-raised-button mat-primary"(click)="save()">Save</button>
</mat-dialog-actions> -->